import { ErrorUI } from '@components/organism/common/ErrorUI.jsx'
import { queryClient } from '@queries/client.js'
import { useTranslation } from 'react-i18next'

const ChunkErrorBoundary = ({ resetErrorBoundary }) => {
  const { t } = useTranslation()
  const hasAlreadyReloaded = sessionStorage.getItem('__CHUNK_RELOAD__')

  // 최초 chunk error 발생 시
  if (!hasAlreadyReloaded) {
    sessionStorage.setItem('__CHUNK_RELOAD__', '1')

    // react-query 캐시 제거
    queryClient.clear?.()
    resetErrorBoundary()

    window.location.replace(window.location.pathname)

    return null
  }

  return (
    <ErrorUI title={t('error.pageLoadFailed.title')} message={t('error.pageLoadFailed.message')} />
  )
}

export default ChunkErrorBoundary
